<div class="db-connect-and-optimize__content">
  <div>
    <h2>Your website optimization starts from your homepage</h2>
    <ul>
      <li *ngFor="let point of points">
        <i class="db-icon db-icon-ds-checkmark"></i>
        <span [innerHTML]="point"></span>
      </li>
    </ul>
    <div class="ds-input-wrap mb10">
      <input class="ds-input" type="text" disabled [value]="websiteUrl">
    </div>

    <button class="ds-btn-green ds-btn-l" (click)="connect()">
      <span>Start Optimizing</span>
    </button>
  </div>

</div>
<div class="db-connect-and-optimize__banner">
  <div>
    <img class="db-connect-and-optimize__banner-img" src="assets/images/backgrounds/booster.png" alt="">
    <div class="db-connect-and-optimize__wp-rating">
      <img class="logo" src="assets/images/logos/services/wp.svg" alt="">
      <img class="stars" src="assets/images/icons/stars.svg" alt="">
      <div class="texts"><span>4.7 out of 5 stars | 10,000 + </span>active users</div>
    </div>
  </div>

</div>
